/* eslint-disable */
import React from 'react';
import { useI18n } from '@oneaudi/i18n-context';
import {
  SYS_SPACE_FIXED_100,
  SYS_SPACE_FIXED_350,
  SYS_SPACE_FIXED_450,
} from '@oneaudi/unified-web-common';
import styled from 'styled-components';
import filters from '../../../models/filter';
import mapContext from '../../../contexts/map-context';
import { FilterItem } from './FilterItem';

const isLegacy = process.env.IS_LEGACY;

export default function Filters() {
  const { authorDefinedFilters, userSelectedFilters, preselectedFilters } =
    mapContext.useMapState();

  return (
    <Div data-test-id="filters-component">
      {authorDefinedFilters.map((filterKey: string) => {
        return (
          <FilterItem
            key={filterKey}
            filterKey={filterKey}
            label={useI18n(filters[filterKey])}
            isSelected={
              preselectedFilters.includes(filterKey) || userSelectedFilters.includes(filterKey)
            }
            readOnly={preselectedFilters.includes(filterKey)}
            data-test-id="component-filter-item"
          />
        );
      })}
    </Div>
  );
}

const Div = styled.div`
  padding: ${SYS_SPACE_FIXED_450} 0 ${SYS_SPACE_FIXED_350};
  display: inline-flex;
  flex-wrap: wrap;
  gap: ${SYS_SPACE_FIXED_100};
  ${isLegacy && `color: white`}
`;
